import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { CandidateSearchGridComponent } from 'src/app/search-all-candidates/candidate-search-grid/candidate-search-grid.component';
import { State } from 'src/app/search-all-candidates/models/state.model';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { CandidateSearchService } from 'src/app/search-all-candidates/candidate-search.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@UntilDestroy()
@Component({
    selector: 'nova-candidate-search-modal',
    standalone: true,
    imports: [CandidateSearchGridComponent, MatIconModule, ReactiveFormsModule, MatButtonModule, MatDialogModule],
    templateUrl: './candidate-search-modal.component.html',
    styleUrls: ['./candidate-search-modal.component.scss']
})
export class CandidateSearchModalComponent implements AfterViewInit {
    private readonly _title = 'Find a Candidate';

    get count(): number {
        return this.grid.count;
    }

    get title(): string {
        return this.state === State.succeed ? `Results (${this.count})` : this._title;
    }

    get isInitial(): boolean {
        return this.state === State.initial;
    }

    get isLoading(): boolean {
        return this.state === State.loading;
    }

    get isSucceed(): boolean {
        return this.state === State.succeed;
    }

    get hasNoResults(): boolean {
        return this.state === State.noResults;
    }

    searchText = new UntypedFormControl('');

    @ViewChild(CandidateSearchGridComponent, { static: false }) grid: CandidateSearchGridComponent;

    private state: State = State.initial;

    constructor(private readonly _candidateSearchService: CandidateSearchService) {}

    ngAfterViewInit() {
        this.grid.isLoading$.pipe(untilDestroyed(this)).subscribe((isLoading) => {
            if (this.isInitial) {
                return;
            }

            if (!isLoading) {
                this.state = this.grid.count ? State.succeed : State.noResults;
            }
        });
    }

    searchCandidates(searchText: string) {
        if (this.isLoading) {
            return;
        }

        if (!searchText || searchText.trim().length < 3) {
            return;
        }

        const filter = this._candidateSearchService.createFilter(searchText);
        if (!filter) {
            this.state = State.noResults;
        } else {
            this.grid.quickSearchCandidates(filter);
            this.state = State.loading;
        }
    }
}
